import React from 'react';
import Icon from '../Icon';

const SolutionCard = ({ icon, title, body }) => (
  <div className="solution-card reveal">
    <div className="ic-wrap"><Icon name={icon} size={22} stroke={1.8} /></div>
    <h3>{title}</h3>
    <p>{body}</p>
  </div>
);

const Solution = ({ onCTA }) => (
  <section id="how" className="section-solution">
    <div className="container">
      <div className="section-head">
        <span className="eyebrow">Our approach</span>
        <h2 className="section-title">
          We make it simple to <em>get paid</em> for the care you're already providing.
        </h2>
        <p className="section-lede">
          No bureaucracy. No confusion. Just a real person walking you through every form,
          every call, every step — until the money lands in your account.
        </p>
      </div>

      <div className="solution-grid">
        <SolutionCard icon="compass" title="Check eligibility" body="Answer a few questions in 2 minutes. We tell you which programs you may qualify for in your state." />
        <SolutionCard icon="dollar" title="Get estimates" body="Get a real estimate of your monthly payment based on hours of care, recipient income, and program rules." />
        <SolutionCard icon="document" title="We do the paperwork" body="Applications, supporting documents, doctor verifications — we prepare them and walk you through signing." />
        <SolutionCard icon="phone" title="A real person, every step" body="A dedicated care advocate who knows your case, picks up the phone, and follows through to approval." />
      </div>
    </div>
  </section>
);

export default Solution;
